module.exports = __webpack_public_path__ + "img/icdeposit.4c3320fe.png";